import apiClient from '@/services/api_client_crm.js'

const INITIAL = 0
const IN_PROGRESS = 1
const REQUESTED = 2

export const state = {
  invoices: [],
  paymentMethods: [],
  status: INITIAL
}

export const mutations = {
  SET_INVOICES (state, value) {
    state.invoices = value
  },
  SET_PAYMENT_METHODS (state, value) {
    state.paymentMethods = value
  }
}

export const getters = {
  paymentMethods: state => {
    return (typeof state.paymentMethods !== 'undefined') ? state.paymentMethods : []
  },
  invoices: state => {
    return (typeof state.invoices !== 'undefined') ? state.invoices : []
  }
}

export const actions = {
  loadPayments ({ state, commit, rootState }) {
    if (state.status === INITIAL) {
      state.status = IN_PROGRESS
      return apiClient
        .get('/api/payments')
        .then(response => {
          this.commit('SET_INVOICES', response.data.invoices)
          this.commit('SET_PAYMENT_METHODS', response.data.payment_methods)
          state.status = REQUESTED
        })
        .catch(err => {
          state.status = INITIAL
          return Promise.reject(err)
        })
    } else {
    }
  }
}
